<template>
  <main>
    <transition mode="out-in">
      <router-view />
    </transition>
    <transition name="app-loading-fade">
      <div v-if="appoverlay" class="app-loading" role="status" aria-live="polite">
        <div class="app-loading__brand" aria-hidden="true">
          <span class="app-loading__emblem"><img src="./assets/logo-ui.png" alt=""></span>
          <span class="app-loading__divider"></span>
          <span class="app-loading__wordmark">
            <span class="app-loading__app">E-Sign</span>
            <span class="app-loading__uni">Universitas</span>
            <span class="app-loading__uni">Indonesia</span>
          </span>
        </div>
        <div class="app-loading__bar"><span></span></div>
        <span class="app-loading__text">Memuat e-Sign…</span>
      </div>
    </transition>
</main>
</template>
<script>
export default {
  data: () => ({
    appoverlay: false
  }),
  methods: {
    showOverlay() {
      this.appoverlay = true
    },
    hideOverlay() {
      this.appoverlay = false
    },
    checkOverlay() {
      if (this.$route.path !== "/" && this.$route.path !== "/home-page") {
        this.showOverlay();
      }
      setTimeout(() => {
        this.hideOverlay()
      }, 2000)
    }
  },
  created() {
    this.checkOverlay()
  }
}
</script>
<style>
/* Splash shown while the app starts: the e-Sign lockup from the navbar, in navy on the page background */
.app-loading {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: var(--esign-bg, #F4F6FA);
}

.app-loading__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  color: var(--esign-navy, #002B81);
}

/* logo-ui.png holds the yellow emblem on its left; show only that part */
.app-loading__emblem {
  display: block;
  width: 56px;
  height: 58px;
  overflow: hidden;
}

.app-loading__emblem img {
  display: block;
  height: 100%;
  width: auto;
  max-width: none;
}

.app-loading__divider {
  width: 2px;
  height: 52px;
  border-radius: 2px;
  background: currentColor;
  opacity: 0.35;
}

.app-loading__wordmark {
  display: flex;
  flex-direction: column;
  text-transform: uppercase;
  white-space: nowrap;
}

/* Serif lettering like the official UI logotype (overrides the global font) */
.app-loading__wordmark,
.app-loading__wordmark * {
  font-family: 'Cinzel', 'Trajan Pro', Georgia, 'Times New Roman', serif !important;
}

.app-loading__app {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0.14em;
  opacity: 0.8;
}

.app-loading__uni {
  font-size: 19px;
  font-weight: 700;
  line-height: 1.1;
  letter-spacing: 0.08em;
}

/* Thin indeterminate bar */
.app-loading__bar {
  position: relative;
  width: 180px;
  height: 3px;
  overflow: hidden;
  border-radius: 3px;
  background: var(--esign-primary-subtle, #E6F1FF);
}

.app-loading__bar span {
  position: absolute;
  top: 0;
  left: 0;
  width: 40%;
  height: 100%;
  border-radius: inherit;
  background: var(--esign-primary, #007DFE);
  animation: app-loading-slide 1.1s ease-in-out infinite;
}

@keyframes app-loading-slide {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(250%); }
}

.app-loading__text {
  color: var(--esign-text-muted, #5B6B86);
  font-size: 13px;
  font-weight: 500;
}

.app-loading-fade-leave-active {
  transition: opacity 0.25s ease;
}

.app-loading-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .app-loading__bar span {
    animation: none;
    width: 100%;
    opacity: 0.6;
  }

  .app-loading-fade-leave-active {
    transition: none;
  }
}
</style>
